import React, { useState } from 'react';
import Menu, { TriggerProps } from '../../Menu/Menu';
import MenuItem from '../../Menu/MenuItem';
import shareIcon from '../../../../static/icons/share.svg';
import followIcon from '../../../../static/icons/follow.svg';
import trashIcon from '../../../../static/icons/trash.svg';
import exportIcon from '../../../../static/icons/download.svg';
import pdfIcon from '../../../../static/icons/documentsType/pdf.svg';
import excelIcon from '../../../../static/icons/documentsType/excel.svg';
import CellTrigger from '../../Menu/MenuTriggers/CellTrigger';
import { connect } from 'react-redux';
import { RootState } from '../../../../state/store/store';
import { exportTypes } from '../../../../state/ducks/allShipmentsPage/allShipmentsPage';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { userSelectors } from '../../../../state/ducks/user/selectors';
import CustomModal, { ModalTriggerProps } from '../../Modal/Modal';
import ShareShipmentForm from '../../ShareShipmentForm/ShareShipmentFormConnected';
import InviteUserFollowShipmentForm from '../../InviteUserFollowShipmentForm/InviteUserFollowShipmentForm';
import { shipmentsSelectors } from '../../../../state/ducks/shipments/selectors';
import { allowedCompany } from '../../../../models/entities/user';
import { PagesRoutes } from '../../../../routing/PagesRoutes';
import ShipmentPdfDocument from '../../../pages/singleShipment/ShipmentPdfDocument';
import { PDFViewer } from '@react-pdf/renderer';
import { settings as shipmentSettingType, shipment } from '../../../../models/entities/shipment/shipment';
import { featureFlagsModel } from '../../../../models/entities/businessPartner/settings';
import { businessPartnersSelectors } from '../../../../state/ducks/businessPartner/selectors';
import { settings } from '../../../../models/entities/businessPartner/businessPartner';
import { singleShipmentSelectors } from '../../../../state/ducks/singleShipment/selectors';
import { shipmentPdfSvgIconsType } from '../../../../state/ducks/singleShipment/singleShipment';
import { claimsDomainsType } from '../../../../userClaims';
import claimsType from '../../../../models/entities/claimsType';

type exportDataRowProps = (shipmentId: string, type: exportTypes, fileName: string) => Promise<boolean>;
type Props = {
    shipment: shipment;
    entityId: string;
    entityData: { CargoZoneNumber: string; companyId: string };
    localization: any;
    singleShipmentLocalization: any;
    settings: settings;
    shipmentSettings: shipmentSettingType;
    exportDataRow: exportDataRowProps;
    trigger?: (props: TriggerProps) => JSX.Element;
    deleteShipment: (shipmentId: string) => Promise<any>;
    onDelete?: () => void;
    followShipment: (shipmentId: string) => void;
    unFollowShipment: (shipmentId: string) => void;
    getShipmentIsActiveById: (shipmentId: string) => boolean;
    updateShipmentIsActive: (shipmentId: string, isActive: boolean) => void;
    followingShipments?: Array<string>;
    allowedCompanies: allowedCompany[];
    featureFlags?: featureFlagsModel;
    shipmentPdfSvgIcons: shipmentPdfSvgIconsType;
    getUserClaims: (domain: claimsDomainsType) => claimsType;
};

const ShipmentMenu = ({
    shipment,
    entityId,
    entityData,
    localization,
    singleShipmentLocalization,
    exportDataRow,
    deleteShipment,
    trigger,
    onDelete,
    followShipment,
    unFollowShipment,
    updateShipmentIsActive,
    getShipmentIsActiveById,
    followingShipments,
    allowedCompanies,
    shipmentSettings,
    settings,
    shipmentPdfSvgIcons,
    getUserClaims
}: Props) => {
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [shareModalVisible, setShareModalVisible] = useState(false);
    const [inviteModalVisible, setInviteModalVisible] = useState(false);
    const [pdfModalVisible, setPdfModalVisible] = useState(false);
    const [pdfViewerVisible, setPdfViewerVisible] = useState(false);

    
    const isUserFollowing = followingShipments?.includes(entityId);
    const isActiveShipment = getShipmentIsActiveById(entityId);

    const menuItemsArr = [
        <MenuItem
            onClick={() => {
                isUserFollowing ? unFollowShipment(entityId) : followShipment(entityId);
            }}
            icon={followIcon}
            text={isUserFollowing ? localization.grid.menu.unfollow : localization.grid.menu.follow}
        />,
        <CustomModal
            isOpen={shareModalVisible}
            title={{ text: localization.grid.menu.share_shipment, icon: shareIcon }}
            Trigger={(props: ModalTriggerProps) => (
                <MenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsModalOpened(true);
                        setShareModalVisible(true);
                    }}
                    icon={shareIcon}
                    text={localization.grid.menu.share}
                />
            )}
            onCancelCallback={() => {
                setIsModalOpened(false);
                setShareModalVisible(false);
            }}
            Content={(setVisible?: React.Dispatch<React.SetStateAction<boolean>>, setConfirm?: React.Dispatch<React.SetStateAction<boolean>>) => {
                return (
                    <ShareShipmentForm
                        shipmentId={entityId}
                        setModalVisible={(visible: boolean) => {
                            setVisible && setVisible(visible);
                            setIsModalOpened(visible);
                        }}
                        featureFlags={undefined}
                        settings={settings}
                        confirmation={setConfirm ? { setConfirm } : undefined}
                    ></ShareShipmentForm>
                );
            }}
            headerPadding="0 32px"
            contentPadding="0 32px"
            containerPadding="32px 0"
            headerHeight={24}
            footerHeight={0}
            headerFontSize="21px"
            width="393px"
            maxWidth="393px"
        />,
        <CustomModal
            isOpen={inviteModalVisible}
            title={{ text: localization.grid.menu.invite_to_follow, icon: followIcon }}
            Trigger={(props: ModalTriggerProps) => (
                <MenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsModalOpened(true);
                        setInviteModalVisible(true);
                    }}
                    icon={followIcon}
                    text={localization.grid.menu.invite_to_follow}
                />
            )}
            onCancelCallback={() => {
                setIsModalOpened(false);
                setInviteModalVisible(false);
            }}
            Content={(setVisible?: React.Dispatch<React.SetStateAction<boolean>>, setConfirm?: React.Dispatch<React.SetStateAction<boolean>>) => {
                return (
                    <InviteUserFollowShipmentForm
                        shipmentId={entityId}
                        setModalVisible={(visible: boolean) => {
                            setVisible && setVisible(visible);
                            setIsModalOpened(visible);
                        }}
                        confirmation={setConfirm ? { setConfirm } : undefined}
                    ></InviteUserFollowShipmentForm>
                );
            }}
            width="393px"
            maxWidth="393px"
        />,
                <MenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        setPdfViewerVisible(true);
                    }}
                    icon={exportIcon}
                    text={localization.grid.menu.export + ' ' + localization.grid.menu.pdf}
                />
    ];

    if (allowedCompanies.find((item) => item.companyId === entityData.companyId)) {
        menuItemsArr.push(
            ...[
                <MenuItem
                    onClick={() => {
                        updateShipmentIsActive(entityId, !isActiveShipment);
                    }}
                    icon={trashIcon}
                    text={`${localization.grid.menu.make_shipment} ${isActiveShipment ? 'inactive' : 'active'}`}
                    requiredConfirm
                />
            ]
        );
        if (getUserClaims('admin').view) {
            menuItemsArr.push(
                <MenuItem
                    onClick={() => {
                        deleteShipment(entityId).then(() => {
                            if (onDelete) onDelete();
                        });
                    }}
                    icon={trashIcon}
                    text={localization.grid.menu.delete}
                    requiredConfirm
                />
            );
        }
    }

    return (
        <>
            <Menu
                menuWidth={165}
                options={menuItemsArr}
                isModalOpened={isModalOpened}
                MenuTrigger={trigger || CellTrigger}
                strStyle="display: flex;align-items: center;width: 100%;height: 100%;"
            />
            {pdfViewerVisible && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        width: '90%',
                        height: '90%',
                        borderRadius: '8px',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            padding: '10px 20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h3 style={{ margin: 0 }}>Shipment PDF - #{shipment.CargoZoneNumber}</h3>
                            <button
                                onClick={() => setPdfViewerVisible(false)}
                                style={{
                                    backgroundColor: '#f0f0f0',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                Close
                            </button>
                        </div>
                        <div style={{ flex: 1, padding: '20px' }}>
                            <PDFViewer width="100%" height="100%" style={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                                <ShipmentPdfDocument
                                    shipment={shipment}
                                    localization={singleShipmentLocalization}
                                    featureFlags={undefined}
                                    shipmentSettings={shipmentSettings}
                                    settings={settings}
                                    shipmentIcons={shipmentPdfSvgIcons}
                                    users={[]}
                                />
                            </PDFViewer>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    const businessPartnerSettings = businessPartnersSelectors.settingsByLanguage(state);
    const shipmentSettingsSelector = shipmentsSelectors.settingsByLanguage(state);
    const shipmentSettings = typeof shipmentSettingsSelector === 'function' ? shipmentSettingsSelector() : shipmentSettingsSelector;

    return {
        localization: localizationSelectors.allShipmentsPage(state),
        singleShipmentLocalization: localizationSelectors.singleShipmentPage(state),
        followingShipments: userSelectors.followingShipments(state),
        getShipmentIsActiveById: (shipmentId: string) => shipmentsSelectors.getShipmentIsActiveById(state)(shipmentId),
        allowedCompanies: userSelectors.allowedCompanies(state),
        settings: businessPartnerSettings,
        shipmentSettings: shipmentSettings,
        shipmentPdfSvgIcons: singleShipmentSelectors.shipmentPdfSvgIcons(state),
        getUserClaims: (domain: claimsDomainsType) => userSelectors.getUserClaims(state)(domain)
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    exportDataRow: async (shipmentId: string, type: exportTypes, fileName: string) =>
        dispatch.allShipmentsPage.exportDataRow({ shipmentId, type, fileName }),
    deleteShipment: async (shipmentId: string) => dispatch.allShipmentsPage.deleteShipment(shipmentId),
    followShipment: async (shipmentId: string) => dispatch.allShipmentsPage.followShipment(shipmentId),
    unFollowShipment: async (shipmentId: string) => dispatch.allShipmentsPage.unFollowShipment(shipmentId),
    updateShipmentIsActive: async (shipmentId: string, isActive: boolean) =>
        dispatch.allShipmentsPage.updateShipmentIsActive({ shipmentId, isActive })
});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentMenu);